// extracted by mini-css-extract-plugin
export default {"item":"Item_item__MgYLy","position":"Item_position__+FXim"};